<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
  <div class="row row-for-levels">
    <div class="col-md-3 text-align-left label-padding-left-10px">
      <label for="diaplayName" class="margin-bottom-0px margin-top-5px label-color"><span>*</span> {{field.Title}}</label>
    </div>

    <div class="col-md-4 label-padding-top-2px">
      <CodeTypeValue [CodeType]="field.ValueSource"
                     id="CurrentActorAddEmergencyInfoRequest.RelationType"
                     [(ngModel)]="field.Value" SelectedValue="field.Value"
                     name="field.Value">
      </CodeTypeValue>


    </div>
  </div>


</div>
<!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="FormMode=='View'">
  <div class="row">
    <div class="col-md-3 text-align-right">
      <label for="diaplayName"><span>*</span> {{field.Title}}</label>
    </div>

    <div class="col-md-4">
      <label for="diaplayName"><span>*</span> {{field.Value}}</label>
      

    </div>
  </div>


</div>-->
<div class="form-group col-md-12 col-xs-12 margin-bottom-3px" *ngIf="mode=='view'">
  <div class="row row-for-levels">
    <div class="col-md-3 text-align-left label-padding-left-10px">
      <label for="diaplayName" class="margin-bottom-0px margin-top-5px label-color">{{field.Title}}</label>
    </div>
    <div class="col-md-1 font-weight-bold margin-top-5px">:</div>
    <div class="col-md-4 label-padding-top-2px">
      <!--<CodeTypeValue [CodeType]="field.ValueSource"
                 id="CurrentActorAddEmergencyInfoRequest.RelationType"
                 [(ngModel)]="field.Value" SelectedValue="field.Value"
                 name="field.Value">
  </CodeTypeValue>-->
      <label for="diaplayName" class="margin-bottom-0px margin-top-5px font-weight-normal">{{field.Value}}</label>

    </div>
  </div>


</div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-3px" *ngIf="mode=='view2'">
  <div class="row row-for-levels font-size-14">
    <div class="col-md-5 text-align-left label-padding-left-10px">
      <label for="diaplayName" class="margin-bottom-0px margin-top-5px label-color white-space-pre">{{field.Title}}</label>
    </div>
    <div class="col-md-1 font-weight-bold margin-top-5px">:</div>
    <div class="col-md-5 label-padding-top-2px">
      <!--<CodeTypeValue [CodeType]="field.ValueSource"
                     id="CurrentActorAddEmergencyInfoRequest.RelationType"
                     [(ngModel)]="field.Value" SelectedValue="field.Value"
                     name="field.Value">
      </CodeTypeValue>-->
      <label for="diaplayName" class="margin-bottom-0px margin-top-5px font-weight-normal">{{field.Value}}</label>

    </div>
  </div>


</div>
